import styled from "styled-components";
import { device, mq } from "lib/media-query";

export const Link = styled.a`
    color: #000;
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-right: 8px;

    ${mq.from(device.TABLET)`
      margin-right: 24px;
  `}

    ${mq.to(device.TABLET)`
    grid-column-start: 1;
    grid-column-end: span 2;
    span {
      display: none;
    }
  `}

  &:hover {
        color: #444;
        text-decoration: none;
    }
`;
